import React from 'react';
import { getWidth } from '../../utils/getWidth';
import { TabItemsProps } from '../TabItems/TabItems.types';
import { InjectedWithMaxWidthProps } from './WithMaxWidth.types';

type State = {
  itemMaxWidth: number | undefined;
};

const WithMaxWidth = (
  WrappedComponent: React.ComponentType<
    TabItemsProps & InjectedWithMaxWidthProps
  >,
): React.ComponentType<TabItemsProps> => {
  const getMaxWidth = (
    items: TabItemsProps['items'],
    containerWidth: number,
  ) => {
    const COMPACT_SIDE_MARGIN = 18;
    const marginsBetweenItems = COMPACT_SIDE_MARGIN * 2 * (items.length - 1);
    return (containerWidth - marginsBetweenItems) / items.length;
  };

  return class Wrapper extends React.Component<TabItemsProps, State> {
    state = {
      itemMaxWidth: undefined,
    };

    initMaxWidth(itemsContainer: HTMLDivElement | null) {
      const { type, items } = this.props;

      if (!itemsContainer || type !== 'compactSide') {
        return;
      }

      const itemMaxWidth = getMaxWidth(items, getWidth(itemsContainer));
      if (this.state.itemMaxWidth !== itemMaxWidth) {
        this.setState({ itemMaxWidth });
      }
    }

    render() {
      return (
        <div ref={el => this.initMaxWidth(el)} style={{ width: '100%' }}>
          <WrappedComponent
            {...this.props}
            itemMaxWidth={this.state.itemMaxWidth}
          />
        </div>
      );
    }
  };
};

export default WithMaxWidth;
